import { QueryClient } from "@tanstack/react-query";

// Wave 3 C5 — one client for the whole app. Admin lists default to 60s freshness
// so back-navigation renders instantly from cache without a refetch.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 1,
    },
  },
});

export const qk = {
  adminShell: ["admin-shell"],
  dashboardBundle: ["dashboard-bundle"],
  bookings: (params) => ["bookings", params ?? {}],
  quotes: (params) => ["quotes", params ?? {}],
  orders: ["orders"],
  items: (params) => ["catalog", "items", params ?? {}],
  categories: ["catalog", "categories"],
  packages: ["catalog", "packages"],
  customers: (params) => ["customers", params ?? {}],
  schedule: (start, end) => ["schedule", start, end],
  dispatchBoard: (date) => ["dispatch-board", date],
  microsite: (id) => ["microsite", id],
  cartRecovery: (days) => ["cart-recovery", days],
  revenueTrend: (days) => ["revenue-trend", days],
};
